<template>
	<div :class="{ row: display === 'row', errormessage: error && error != ''}">
		<div>
			<label v-if="label" :for="identifier" :style="{ width: labelWidth + 'px' }">{{label}}</label>
			<input :id="identifier" :name="identifier" :type="getType" @change="$emit('input', $event.target.value); $emit('valueChanged');" :value="value" v-bind="attrs" @wheel="handleScroll">
		</div>
		<div class="error">
			<span v-if="error" class="errormessage">{{error}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TextInput',
		computed: {
			getType() {
				if (this.type === 'password') return 'password';
				else if (this.type === 'number') return 'number';
				else return 'text';
			}
		},
		props: ['label', 'value', 'identifier', 'display', 'labelWidth', 'type', 'attrs', 'error'],
		methods: {
			handleScroll(e) {
				e.target.blur()
			}
		}
	}
</script>

<style lang="scss" scoped>
    $lightgrey: #afafaf;

	div.row > div{
		display:flex;
    }

	label{
		margin-top:8px;
		margin-bottom:5px;
		display:block;
    }

    input{
        padding: 7px;
        width:100%;
        border: 1px solid #e4e4e4;
    }

    input::-webkit-input-placeholder {
        color: $lightgrey;
    }

    input::-moz-placeholder {
        color: $lightgrey;
    }

    input:-ms-input-placeholder {
        color: $lightgrey;
    }

    input:-moz-placeholder {
        color: $lightgrey;
    }

	.error {
		position:absolute;
		right:0;
		padding-top:3px;
		font-size:0.8em;
		color:#d43131;
	}

	.error span {
		width: 100%;
		text-align: right;
	}

	.errormessage input {
		border-color: #d43131;
	}
</style>
